export default "__VITE_ASSET__y$Xh7QTk__"